import type { GameSummary, ProductGame } from "../types/product";

async function getJson<T>(primary: string, fallback: string): Promise<T> {
  try {
    const response = await fetch(primary, {
      headers: { Accept: "application/json" },
    });
    if (response.ok) return (await response.json()) as T;
  } catch {
    // Static fallback keeps the client usable when the route facade is unavailable.
  }

  const response = await fetch(fallback, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error("Unable to load data.");
  }

  return (await response.json()) as T;
}

export function fetchGames(): Promise<GameSummary[]> {
  return getJson<GameSummary[]>("/api/v1/games", "/data/games.json");
}

export function fetchGame(gameId: string): Promise<ProductGame> {
  const encoded = encodeURIComponent(gameId);
  return getJson<ProductGame>(
    `/api/v1/games/${encoded}`,
    `/data/game-details/${encoded}.json`,
  );
}

export function fetchPerformance(): Promise<Record<string, unknown>> {
  return getJson<Record<string, unknown>>(
    "/api/v1/performance",
    "/data/performance.json",
  );
}
